import React from "react";
import {observable, toJS} from 'mobx';
import {observer} from 'mobx-react';

import {DatePicker, Row, Col, Input, Select, Radio, AutoComplete, Button, Icon, TreeSelect} from 'antd';

import moment from 'moment';
import MyAgentAutoComplete from '@ViewsDashboard/Common/MyAgentTreeSelect';
import CustomerTypeSelect from '@ViewsDashboard/Common/CustomerTypeSelect';
import login_user_store from "../../Store/LoginUser/LoginUserStore";

// const { RangePicker } = DatePicker;

const Option = Select.Option;

@observer
class MySearchComponent extends React.Component {

  /**
   * 时间转换用于设置DatePicker默认值
   * @param startDateString
   * @param endDateString
   * @param timeFormat 时间格式
   * @returns {(*|moment.Moment)[]}
   */
  static getDateFromString = (startDateString,endDateString,timeFormat='YYYY-MM-DD') => {
    return [moment(startDateString,timeFormat),moment(endDateString,timeFormat)]
  }
  /**
   * 时间转换用于设置DatePicker默认值
   * @param startTimestamp 13位时间戳
   * @param endTimestamp 13位时间戳
   * @returns {(*|moment.Moment)[]}
   */
  static getDateFromTimestamp = (startTimestamp,endTimestamp) => {
    return [moment(Number(startTimestamp)),moment(Number(endTimestamp))]
  }
  /**
   * 时间转换用于设置DatePicker默认值
   * @param startUnix 10位时间戳
   * @param endUnix 10位时间戳
   * @returns {moment.Moment[]}
   */
  static getDateFromUnix = (startUnix,endUnix) => {
    return [moment.unix(Number(startUnix)),moment.unix(Number(endUnix))]
  }

  static getTypeId(type) {
    return CustomerTypeSelect.getTypeId(type);
  }

  @observable
  currentValue;


  constructor(props)
  {
    super();
    this.updateValue(props)
  }
  componentWillReceiveProps(props){
    this.updateValue(props)
  }

  updateValue(props)
  {
    this.currentValue = {
      agent:'',
      typeMode:CustomerTypeSelect.TYPE_MODE_AGENT,
      type:CustomerTypeSelect.TYPE_AGENT_ALL,
      search:'',
      date:[],
      ...props.defaultValue
    };
  }

  render() {

    let dateDefault = [];

    if (this.currentValue.date.length != 0)
    {
      dateDefault = MySearchComponent.getDateFromUnix(this.currentValue.date[0],this.currentValue.date[1]);
    }

    let typeSelectStyle = {}

    if (this.props.hideAutoComplete)
    {
      typeSelectStyle = {
        marginLeft: '15px'
      }
    }

    let autoCompleteDefault = toJS(this.currentValue.agent);
    if (autoCompleteDefault == '')
    {
      autoCompleteDefault = login_user_store.pet_name;
    }

    return (
      <div style={{
        display:'flex',
        height:'35px',
        alignItems:'center'
      }}>
        <Input.Group
          style={{
            width:'auto'
          }}
          compact
        >
        {/* {
          this.props.hideAutoComplete ? null :
            (
              <MyAgentAutoComplete
                style={{
                  width:'150px'
                }}
                defaultValue={autoCompleteDefault}
                onChange={(value) => {
                  // console.log("fff",value)
                  this.currentValue.agent = value;
                }}
              />
            )
        } */}
        {/* {
          this.props.hideTypeSelect ? null :
            (
              <CustomerTypeSelect
                style={typeSelectStyle}
                typeMode={toJS(this.currentValue.typeMode)}
                defaultValue={toJS(this.currentValue.type)}
                onChange={(value) => {
                  this.currentValue.type_time = 6
                  this.currentValue.type = value;
                }}

              />
            )
        } */}
        </Input.Group>
        {
          this.props.hideSearchInput ? null :
            (
              <Input
                style={{
                  width:'120px',
                  marginLeft: '15px',
                }}
                size={'small'}
                defaultValue={toJS(this.currentValue.search)}
                placeholder='昵称/账号'
                onChange={(value) => {
                  this.currentValue.search = value.target.value;
                }}
              />
            )
        }
        {
          this.props.hideDatePicker ? null :
            (
              <Select defaultValue="6" style={{ width: '130px',marginLeft: '15px' }} size={'small'}                 
              onChange={(value)=>{
                  this.currentValue.type_time = Number(value);
                  }}
                >
              <Option value="6">今日</Option>
              <Option value="5">昨日</Option>
              <Option value="4">本周</Option>
              <Option value="3">上周</Option>
              <Option value="2">本月</Option>
              <Option value="1">上月</Option>
            </Select>
              // <RangePicker
              //   style={{
              //     width:'230px',
              //     marginLeft: '15px',
              //   }}
              //   size={'small'}
              //   defaultValue={toJS(dateDefault)}
              //   onChange={(dates, dateStrings)=>{

              //     if (dates.length == 0)
              //     {
              //       this.currentValue.date = [];
              //     }
              //     else
              //     {
              //       this.currentValue.date = [new Date(dates[0]).getStartTimestamp(),new Date(dates[1]).getEndTimestamp()];
              //     }
              //   }}
              // />
              
            )
        }
        <Button
          style={{
            marginLeft: '15px',
          }}
          size={'small'}
          type="primary"
          shape="circle"
          icon="search"
          onClick={()=>{

            this.props.onClick(toJS(this.currentValue))

          }}
        />


      </div>
    )

  }
}

export default MySearchComponent;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Common/MySearchComponent.jsx